import React from "react";
import { SupCopy, SupDiscord, SupLinkExternal, SupShare, SupTelegram, SupTwitter } from "@repo/core-ui";
import Link from "next/link";

import UiDetailsAtomSingleLink from "@/components/Ui/Details/Atom/SingleLink";
import { extractFromUrl, notifyMessage } from "@/utils";

interface UiDetailsAtomLinksProps {
  links?: {
    twitter?: string;
    discord?: string;
    telegram?: string;
    website?: string;
  };
  shareLink: string;
}

export default function UiDetailsAtomLinks({ links = {}, shareLink }: UiDetailsAtomLinksProps) {
  const handleCopy = async () => {
    const url = window.location.protocol + "//" + window.location.host + `/${shareLink}/`;
    await navigator.clipboard.writeText(url);

    notifyMessage("URL successfully copied to clipboard", `${url}`, "success", <SupCopy />);
  };

  return (
    <div className="flex items-center gap-2 ">
      {links.discord && (
        <Link prefetch={false} href={links.discord} target="_blank">
          <UiDetailsAtomSingleLink icon={<SupDiscord className="stroke-0" />} />
        </Link>
      )}
      {links.twitter && (
        <Link prefetch={false} href={links.twitter} target="_blank">
          <UiDetailsAtomSingleLink icon={<SupTwitter className="stroke-0" />} />
        </Link>
      )}
      {links.telegram && (
        <Link prefetch={false} href={links.telegram} target="_blank">
          <UiDetailsAtomSingleLink icon={<SupTelegram className="stroke-0" />} />
        </Link>
      )}
      {links.website && (
        <Link prefetch={false} href={links.website} target="_blank">
          <UiDetailsAtomSingleLink title={extractFromUrl(links.website)} icon={<SupLinkExternal className="stroke-0" />} />
        </Link>
      )}
      <UiDetailsAtomSingleLink onClick={handleCopy} title="Share" icon={<SupShare className="stroke-0" />} />
    </div>
  );
}
